'use client';

import dynamic from 'next/dynamic';

import { Place } from '@/types';

const ClientBestofCategoryPage = dynamic(() => import('./ClientBestofCategoryPage'), {
  ssr: false,
});

interface CategoryStats {
  avgRating?: number;
  avgReviews?: number;
  avgPhotos?: number;
  count?: number;
}

interface BestofCategoryPageWrapperProps {
  category: string;
  places: Place[];
  stats: CategoryStats;
}

export default function BestofCategoryPageWrapper(props: BestofCategoryPageWrapperProps) {
  return <ClientBestofCategoryPage {...props} />;
}
